import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const salaryAdvanceListService = (
  params: Types.SalaryAdvanceListRequest
) =>
  RestAPIClient.call<Types.SalaryAdvanceListResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryAdvanceListShortService = (
  params: Types.SalaryAdvanceListRequest
) =>
  RestAPIClient.call<Types.SalaryAdvanceListShortResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.ListShort,
    config: {
      requireAuthentication: true,
      byPassError: true,
      params,
    },
  });

export const salaryAdvanceCreateService = (
  params: Types.SalaryAdvanceCreateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data: params,
  });

export const salaryAdvanceUpdateService = (
  params: Types.SalaryAdvanceUpdateRequest
) =>
  RestAPIClient.call<unknown>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Update}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "id"),
  });

export const salaryAdvanceDetailService = (id: string) =>
  RestAPIClient.call<Types.SalaryAdvanceDetail>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", String(id)),
    config: {
      requireAuthentication: true,
    },
  });

export const salaryAdvanceDeleteService = (id: string) =>
  RestAPIClient.call<Types.SalaryAdvanceDetail>({
    method: HTTPRequestMethods.DELETE,
    url: Paths.Detail.replace("{id}", String(id)),
    config: {
      requireAuthentication: true,
    },
  });

export const salaryAdvanceBankTransferExportService = (params: {
  page: number | null;
  limit: number | null;
  salaryAdvanceId: string | null;
  bankCode?: string | null;
}) =>
  RestAPIClient.call<Types.SalaryAdvanceBankTransferExportResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.BankTransfer,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryAdvanceDetailEmployeeService = (params: {
  id: string;
  page?: number | null;
  limit?: number | null;
  status?: number | null;
  empCode?: string | null;
}) =>
  RestAPIClient.call<Types.SalaryAdvanceListEmployeeResponse>({
    method: HTTPRequestMethods.GET,
    url: Paths.DetailEmployee.replace("{id}", String(params.id)),
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const salaryAdvanceApprovalStatusService = (params: {
  year?: number | null;
  month?: number | null;
  templateId?: string | null;
  templatePeriod?: number | null;
  paymentId?: string | null;
  cycleId?: string | null;
}) =>
  RestAPIClient.call<Types.SalaryApprovalStatusItem>({
    method: HTTPRequestMethods.GET,
    url: Paths.ApprovalStatus,
    config: {
      requireAuthentication: true,
      params,
    },
  });
